<template>
  <div class="admin-test-analytics">

    <table>

      <thead>
        <tr>
          <td></td>
          <th><i class="fa fa-line-chart"/><br>mixpanel</th>
          <th><i class="fa fa-bug"/><br>bugsnag</th>
        </tr>
      </thead>

      <tbody>
        <tr>
          <th>client <i class="fa fa-laptop"/></th>
          <td>
            <button class="btn btn-sm btn-outline-primary" type="button" @click="sendMixpanelEventFromClient">
              <i class="fa fa-paper-plane"></i>
            </button>
          </td>
          <td>
            <button class="btn btn-sm btn-outline-primary" type="button" @click="sendBugsnagEventFromClient">
              <i class="fa fa-paper-plane"></i>
            </button>
          </td>
        </tr>
        <tr>
          <th>server <i class="fa fa-server"/></th>
          <td>
            <button class="btn btn-sm btn-outline-primary" type="button" @click="sendMixpanelEventFromServer">
              <i class="fa fa-paper-plane"></i>
            </button>
          </td>
          <td>
            <button class="btn btn-sm btn-outline-primary" type="button" @click="sendBugsnagEventFromServer">
              <i class="fa fa-paper-plane"></i>
            </button>
          </td>
        </tr>
      </tbody>
    </table>

  </div>
</template>


<script>
import axios from "axios";
import analytics from "@/analytics";

export default {
  name: "AdminTestAnalytics",
  methods: {
    sendMixpanelEventFromServer() {
      axios.post('/api/admin/mixpanel-test-event')
          .then(() => console.log('mixpanel test event triggered on server'))
          .catch(err => console.log(err));
    },
    sendMixpanelEventFromClient() {
      analytics.sendEvent('test_event_from_client', {});
      console.log('mixpanel test event triggered on client');
    },

    sendBugsnagEventFromServer() {
      axios.post('/api/admin/bugsnag-test-event')
          .then(() => console.log('bugsnag test event triggered on server'))
          .catch(err => console.log(err));
    },

    sendBugsnagEventFromClient() {
      analytics.sendBugsnagTestEvent();
      console.log('bugsnag test event triggered on client');
    },

  }
}
</script>


<style scoped>
.admin-test-analytics {
  margin-top: 30px;
}

td, th {
  text-align: center;
}


thead th {
  padding: 0 0.5em 0.25em 0.5em;
}

tbody {
  th {
    text-align: right;
    padding-right: 0.25em;
  }
  td {
    padding: 0.25em;
  }
}

</style>